// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__H6i9S"};